import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';

// Arc's standard line-height multiplier (1.5× font size)
const ARC_LINE_HEIGHT_MULTIPLIER = 1.5;
// Extra buffer to avoid a false multi-line reading from sub-pixel rounding
const MULTI_LINE_THRESHOLD_BUFFER_PX = 4;

interface MultiLineDetectorPluginProps {
    fontSize: string;
    onMultiLineChange: (isMultiLine: boolean) => void;
}

export function MultiLineDetectorPlugin({
    fontSize,
    onMultiLineChange,
}: MultiLineDetectorPluginProps) {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        const el = editor.getRootElement();
        if (!el) return;
        const singleLineContentHeight = parseFloat(fontSize) * ARC_LINE_HEIGHT_MULTIPLIER;

        const observer = new ResizeObserver((entries) => {
            const { height } = entries[0].contentRect;
            onMultiLineChange(height > singleLineContentHeight + MULTI_LINE_THRESHOLD_BUFFER_PX);
        });

        observer.observe(el);
        return () => observer.disconnect();
    }, [editor, fontSize, onMultiLineChange]);

    return null;
}
